module.exports = __webpack_public_path__ + "de3c770d04623a2df2810eb8f538d20f.jpg";